import React from "react";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";
import {useContactsData} from "../../hooks/useContactsData";
import {getContactsData} from "../../state/selectors";
import LoadingSpinner from "../Utils/Spinner";
import {useSelector} from "react-redux";



export default function ContactSection(props){
    const dataLoaded = useContactsData({partial_view: "YES"});
    const data = useSelector(getContactsData);

    if(!dataLoaded){
        return (
            <LoadingSpinner/>
        )
    }

    return (
        <Box>
            <Title size="5">Incomplete Contacts</Title>
            <Columns isMultiline>

                <Column>
                    <Table>
                        <thead>
                            <tr>
                                <th>Display Name</th>
                                <th>Contact Type</th>
                            </tr>
                        </thead>
                        <tbody>
                        {data.results.map(contact => (
                            <tr>
                                <td>{contact.display_name}</td>
                                <td>{contact.contact_type === "CC" ? "Customer" : "Supplier"}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Column>
            </Columns>
        </Box>
    );


}